<template>
    <v-card>
        <v-card-title>
            输血不良反应反馈
            <v-spacer></v-spacer>
            <router-link style="" to="/">
                <v-img src="../assets/newclose.png"></v-img>
            </router-link>
        </v-card-title>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="搜索"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-actions>

        <v-data-table
                :headers="headers"
                :items="applications"
                :search="search"
                :loading="loading"
                loading-text="正在查询"
                no-data-text="您没有反馈记录"
        >
            <template v-slot:item.staus="{ item }">
                {{item.receiveStatus}}
            </template>
            <template v-slot:item.option="{ item }">
                <v-icon @click="edit(item)" class="mr-2">mdi-pencil</v-icon>
<!--                <v-icon @click="[dialog = true,deleteTmp = item]">mdi-delete</v-icon>-->
            </template>
        </v-data-table>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="500">
                <v-card>
                    <v-card-title class="headline">提示</v-card-title>
                    <v-card-text>
                        确认删除吗？
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#368FC8" @click="dialog = false">取消</v-btn>
                        <v-btn color="#368FC8" @click="deleteTransfusionReaction(deleteTmp)">确认</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-card-actions>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "MyTransfusionReaction",
        inject: ['reload'],
        data: () => ({
            search: '',
            loading: true,
            dialog: false,
            deleteTmp: "",
            baseUrl: window.location.href.substring(0, window.location.href.indexOf('webapp')),
            headers: [
                {
                    text: ' 反馈编号',
                    align: 'center',
                    sortable: false,
                    value: 'id',
                },
                {text: '性别', align: 'center', sortable: false, value: 'sex',},
                {text: '年龄', align: 'center', sortable: false, value: 'age'},
                {text: '民族', align: 'center', sortable: false, value: 'nation'},
                {text: '反馈人', align: 'center', sortable: false, value: 'reporter'},
                {text: '反馈科室', align: 'center', sortable: false, value: 'reportDept'},
                {text: '反馈时间', align: 'center', value: 'createTime'},
                {text: '操作', align: 'center', sortable: false, value: 'option'},
            ],
            applications: []
        }),
        mounted() {
            if (!this.$store.state.landing) {
                this.$snackbar.info('请登录后操作');
                this.$router.push({path: '/login'});
            } else {
                this.getList();
            }
        },
        methods: {
            getList() {
                this.$axios.get('/transfusionreaction/list').then((response) => {
                    if (response.data.success) {
                        this.applications = response.data.data;
                        // this.applications.forEach(n => {
                        //     n.createTime = n.createTime.substring(0, 10);
                        // });
                        this.$snackbar.info(response.data.content);
                        this.loading = false
                    } else {
                        this.$snackbar.info(response.data.content);
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                });
            },

            edit(item) {
                this.$router.push({path: '/transfusionreaction', query: {id: item.id}});
            },

            deleteTransfusionReaction(item) {
                if (item.transfusionDate && item.transfusionDate.indexOf('00:00:00') === -1) {
                    item.transfusionDate += ' 00:00:00';
                }
                if (item.createTime && item.createTime.indexOf('00:00:00') === -1) {
                    item.createTime += ' 00:00:00';
                }
                this.$axios.post('/transfusionreaction/delete', item).then((response) => {
                    if (response.data.success) {
                        this.$snackbar.info(response.data.content);
                        this.reload();
                        this.overlay = false;
                    } else {
                        this.$snackbar.info(response.data.content);
                        this.overlay = false;
                        this.dialog = false;
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                    this.overlay = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>
